import { Model } from "@/models/Model";

export class Supplier extends Model {
  protected $name: string = "Supplier";
  protected $endpoint: string = "/suppliers";
  protected $fillable: string[] = [
    "name",
    "short_name",
    "phone",
    "email",
    "country",
    "street",
    "city",
    "address_number",
    "address_addition",
    "address_additional_info",
    "zip_code",
    "invoice_address",
    "company",
    "has_different_invoice_address",
    "creditor_code"
  ];

  public name?: string;
  public short_name?: string;
  public has_different_invoice_address?: boolean;
  public id?: string;
  public creditor_code?: string;

  protected static instance?: Supplier;
  public static getInstance(instance: Supplier) {
    if (! this.instance) {
      this.instance = instance;
    }

    return this.instance;
  }
}

export interface Profile {
  street?: string;
  address_number?: string;
  address_addition?: string;
  address_additional_info?: string;
  zip_code?: string;
  city?: string;
  country?: string;
  creditor_code?: string;
  company?: string;
  phone?: string;
  answers?: string;
  invoice_address?: InvoiceAddress;
  zoho_contact_id?: string;
}

export interface InvoiceAddress {
  address_addition?: string;
  company?: string;
  address_additional_info?: string;
  address_number: string;
  city: string;
  street: string;
  zip_code: string;
  country: string;
}
